import React, { useCallback, useEffect, useState } from 'react';
import { Checkbox, FormControlLabel, FormHelperText, TextField, MenuItem } from '@mui/material';
import { withStyles } from 'tss-react/mui';

const getDefaultRootStyle = (theme) => {
  return {
    marginTop: theme.spacing(1),
    '& input': {
      paddingTop: '10px',
      paddingBottom: '10px',
    },
  };
};

export const StyledTextField = withStyles(TextField, (theme) => ({
  root: {
    ...getDefaultRootStyle(theme),
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      marginTop: theme.spacing(1),
      paddingTop: '6px',
      paddingBottom: '6px',
    },
    '& .MuiSelect-outlined.MuiSelect-outlined:focus': {
      background: 'transparent',
    },
    '& .MuiInputBase-root:focus-within:has(.MuiSelect-outlined)': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  },
}));

export const StyledCheckbox = withStyles(Checkbox, (theme) => ({
  root: getDefaultRootStyle(theme),
}));

export const InputCheckbox = (props) => {
  const { onChange, label, value = false, name, checkedIcon, icon, className, style } = props;
  const [isChecked, setChecked] = useState(value);
  const _onChange = useCallback(
    (e) => {
      setChecked((value) => {
        return !value;
      });
    },
    [onChange],
  );

  useEffect(() => {
    setChecked(value);
  }, [value]);

  return (
    <FormControlLabel
      className={className}
      style={style}
      label={label}
      name={name}
      control={<StyledCheckbox name={name} icon={icon} checkedIcon={checkedIcon} checked={isChecked} onChange={_onChange} />}
    />
  );
};

export const InputSelect = (props) => {
  const { data, helperText, classes, ...rest } = props;
  return (
    <>
      <StyledTextField select {...rest}>
        {data.map((option) => {
          return (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          );
        })}
      </StyledTextField>
      <FormHelperText error className={classes.error}>
        {helperText}
      </FormHelperText>
    </>
  );
};
